import { Flex, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { EmberEventFn } from '../../../../types/emberEventFn'
import { AccountDetails } from './elements/AccountDetails'
import { ReconcileStatusToggle } from './elements/ReconcileStatusToggle'

interface BankReconciliationTopActionsProps {
  currentAccountName: string
  onChange: EmberEventFn
}

export const BankReconciliationTopActions = ({
  currentAccountName,
  onChange,
}: BankReconciliationTopActionsProps): ReactElement => {
  return (
    <Flex gap={Spacing.S80}>
      <AccountDetails currentAccountName={currentAccountName} />
      <ReconcileStatusToggle onChange={onChange} />
    </Flex>
  )
}
